import { defineMessages } from "react-intl";
const messages = defineMessages({
    createAccessDeviceTitle: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.title",
        defaultMessage: "Create Access Device",
    },
    createAccessDeviceButtonText: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.button.text",
        defaultMessage: "Create",
    },
    timzeoneSelectorLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.timezoneSelector.label",
        defaultMessage: "Community Timezone",
    },
    deviceIdentifierIsRequired: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.deviceIdentifierIsRequired.label",
        defaultMessage: "Device ID is required",
    },
    tourInstructionsIsRequired: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.tourInstructionsIsRequired.label",
        defaultMessage: "Tour Instructions is required",
    },
    nameIsRequired: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.nameIsRequired.label",
        defaultMessage: "Name is required",
    },
    communityTimezone: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.communityTimezone.label",
        defaultMessage: "Community Timezone",
    },
    communityTimezoneIsRequired: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.communityTimezoneIsRequired.label",
        defaultMessage: "Timezone is required",
    },
    deviceTypeLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.deviceType.label",
        defaultMessage: "Device Type",
    },
    accessTypeLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.accessType.label",
        defaultMessage: "Access Type",
    },
    createAccessDeviceSuccess: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.success",
        defaultMessage: "Access device created successfully",
    },
    manufacturerLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.manufacturer.label",
        defaultMessage: "Manufacturer",
    },
    modelLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.model.label",
        defaultMessage: "Model",
    },
    deviceIdLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.deviceId.label",
        defaultMessage: "Device ID",
    },
    nameLabel: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.name.label",
        defaultMessage: "Name",
    },
    namePlaceholderWhenKeybox: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.keybox.placeholder",
        defaultMessage: "Keep it short and simple. Ex.: A",
    },
    namePlaceholderWhenConcierge: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.concierge.placeholder",
        defaultMessage: "Ex.: Doorman, front-desk, concierge, etc",
    },
    nameLabelWhenConcierge: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.concierge.label",
        defaultMessage: "Who will handover the keys?",
    },
    updateFormDeviceNameTooltip: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.metadata.label",
        defaultMessage: "Will be shown upon check-in",
    },
});
export default messages;
